<template>
  <div class="appointment-content" :style="!client ? 'display: none;' : ''">
    <div v-if="clientId" @click="create()" class="add-button mx-6 mt-2">
      + NOVO AGENDAMENTO
    </div>
    <div class="appointments-content">
      <ListAppointmentsComponent
        :appointments="appointments"
        :hasMoreData="hasMoreData"
        @select="openAppointmentDialog"
        @load-more="loadMore"
      />
    </div>

    <ModalManageCompromise
      :isActive="isModalManageCompromiseActive"
      :data="compromise"
      @close="closeModalManageCompromise"
      @save="appointmentCreated"
      @edit="appointmentUpdated"
    />

  </div>
</template>

<script>
import SchedulingService from '@/services/api/scheduling';
import ListAppointmentsComponent from '@/components/Schedule/ListAppointments';
import ModalManageCompromise from '@/components/Schedule/ModalManageCompromise';

export default {
  props: {
    client: {
      type: Object,
      default: null,
    },
  },
  components: {
    ListAppointmentsComponent,
    ModalManageCompromise,
  },
  data () {
    return {
      isModalManageCompromiseActive: false,
      clientId: null,
      appointments: [],
      currentPage: 1,
      itemsPerPage: 15,
      compromise: {
        day: null,
      },
      hasMoreData: false,
    }
  },
  watch: {
    client: {
      immediate: true,
      handler(client) {
        this.clientId = client ? client.id : null;

        if (client) {
          this.handleSearch();
        } else {
          this.appointments = [];
        }
      },
    },
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.appointments = [];

      if (this.clientId) {
        this.search();
      }
    },
    search() {
      const queryParams = {
        client: this.clientId,
        size: this.itemsPerPage,
        page: this.currentPage,
      };

      SchedulingService.search(queryParams)
        .then((response) => {
          const responseData = response.data;

          if (responseData && responseData.rows) {
            const newAppointments = responseData.rows.filter(appointment => !this.appointments.find(s => s.id === appointment.id));
            this.appointments = [...this.appointments, ...newAppointments];
          }

          this.currentPage = responseData.currentPage || 1;
          const totalPages = responseData.totalPages || 1;
          this.hasMoreData = this.currentPage < totalPages;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadMore() {
      this.currentPage += 1;
      this.search();
    },
    create() {
      let day = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);

      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();

      day = `${day} ${hours}:${minutes}`;

      this.compromise = {
        forecast: day,
        client: this.client,
        title: this.client.name,
      };

      this.isModalManageCompromiseActive = true;
    },
    closeModalManageCompromise() {
      this.isModalManageCompromiseActive = false;
    },
    appointmentCreated() {
      this.isModalManageCompromiseActive = false;
      this.handleSearch();
    },
    appointmentUpdated() {
      this.isModalManageCompromiseActive = false;
      this.handleSearch();
    },
    openAppointmentDialog(appointment) {
      this.compromise = JSON.parse(JSON.stringify(appointment));

      this.isModalManageCompromiseActive = true;
    },
  },
}
</script>

<style lang="scss">
.appointment-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: none !important;
  height: calc(100% - 90px) !important;

  .add-button {
    cursor: pointer;
    text-align: center;
    border: 1px dashed rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    padding: 10px 20px;
    margin-bottom: 15px;
    margin-top: 3px;
  }
}
</style>
